import { j as o } from "./jsx-runtime.DGlMoOmv.js";
import * as r from "react";
import Se from "react-dom";
import { c as ke, u as oe, a as y } from "./index.stoqs9MZ.js";
import { P as T, d as ee } from "./index.DMLWxr4u.js";
import { u as F, b as Ae } from "./index.B4ZV02se.js";
import { u as De } from "./index.BhJrV2wu.js";
import { P as K } from "./index.TrmYLGk6.js";
import { u as re } from "./index.BUG7NYeV.js";
import { c as ae } from "./index.BW3XI7yS.js";
import { D as Fe } from "./index.DNGle7LJ.js";
import { u as Le } from "./index.BZPx6jYI.js";
import { R as Oe } from "./index.BkBvp-m6.js";
import { c as Ke } from "./index.C4-GUKyp.js";
import { F as Ve } from "./ChevronDown20.NQYj4T82.js";
import { c as I } from "./index.CxSWpsOB.js";
var z = globalThis?.document ? r.useLayoutEffect : () => {
};
function k(e) {
  const t = r.useRef(e);
  return r.useEffect(() => {
    t.current = e;
  }), r.useMemo(() => (...n) => t.current?.(...n), []);
}
var A = "NavigationMenu", [H, ie, ze] = ae(A), [$, $e, Ge] = ae(A), [Y, Et] = ke(
  A,
  [ze, Ge]
), [Ue, E] = Y(A), [We, Be] = Y(A), se = r.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: a,
      onValueChange: i,
      defaultValue: s,
      delayDuration: c = 200,
      skipDelayDuration: d = 300,
      orientation: u = "horizontal",
      dir: g,
      ...l
    } = e, [v, C] = r.useState(null), R = F(t, (N) => C(N)), p = De(g), x = r.useRef(0), b = r.useRef(0), M = r.useRef(0), [P, w] = r.useState(!0), [m, f] = oe({
      prop: a,
      onChange: (N) => {
        const j = N !== "", V = d > 0;
        j ? (window.clearTimeout(M.current), V && w(!1)) : (window.clearTimeout(M.current), M.current = window.setTimeout(
          () => w(!0),
          d
        )), i?.(N);
      },
      defaultProp: s ?? "",
      caller: A
    }), h = r.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => f(""), 150);
    }, [f]), _ = r.useCallback(
      (N) => {
        window.clearTimeout(b.current), f(N);
      },
      [f]
    ), S = r.useCallback(
      (N) => {
        m === N ? window.clearTimeout(b.current) : x.current = window.setTimeout(() => {
          window.clearTimeout(b.current), f(N);
        }, c);
      },
      [m, f, c]
    );
    return r.useEffect(() => () => {
      window.clearTimeout(x.current), window.clearTimeout(b.current), window.clearTimeout(M.current);
    }, []), /* @__PURE__ */ o.jsx(
      ce,
      {
        scope: n,
        isRootMenu: !0,
        value: m,
        dir: p,
        orientation: u,
        rootNavigationMenu: v,
        onTriggerEnter: (N) => {
          window.clearTimeout(x.current), P ? S(N) : _(N);
        },
        onTriggerLeave: () => {
          window.clearTimeout(x.current), h();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: h,
        onItemSelect: (N) => {
          f((j) => j === N ? "" : N);
        },
        onItemDismiss: () => f(""),
        children: /* @__PURE__ */ o.jsx(
          T.nav,
          {
            "aria-label": "Main",
            "data-orientation": u,
            dir: p,
            ...l,
            ref: R
          }
        )
      }
    );
  }
);
se.displayName = A;
var G = "NavigationMenuSub", He = r.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: a,
      onValueChange: i,
      defaultValue: s,
      orientation: c = "horizontal",
      ...d
    } = e, u = E(G, n), [g, l] = oe({
      prop: a,
      onChange: i,
      defaultProp: s ?? "",
      caller: G
    });
    return /* @__PURE__ */ o.jsx(
      ce,
      {
        scope: n,
        isRootMenu: !1,
        value: g,
        dir: u.dir,
        orientation: c,
        rootNavigationMenu: u.rootNavigationMenu,
        onTriggerEnter: (v) => l(v),
        onItemSelect: (v) => l(v),
        onItemDismiss: () => l(""),
        children: /* @__PURE__ */ o.jsx(T.div, { "data-orientation": c, ...d, ref: t })
      }
    );
  }
);
He.displayName = G;
var ce = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: a,
    dir: i,
    orientation: s,
    children: c,
    value: d,
    onItemSelect: u,
    onItemDismiss: g,
    onTriggerEnter: l,
    onTriggerLeave: v,
    onContentEnter: C,
    onContentLeave: R
  } = e, [p, x] = r.useState(null), [b, M] = r.useState(/* @__PURE__ */ new Map()), [P, w] = r.useState(null);
  return /* @__PURE__ */ o.jsx(
    Ue,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: a,
      value: d,
      previousValue: Le(d),
      baseId: re(),
      dir: i,
      orientation: s,
      viewport: p,
      onViewportChange: x,
      indicatorTrack: P,
      onIndicatorTrackChange: w,
      onTriggerEnter: k(l),
      onTriggerLeave: k(v),
      onContentEnter: k(C),
      onContentLeave: k(R),
      onItemSelect: k(u),
      onItemDismiss: k(g),
      onViewportContentChange: r.useCallback((m, f) => {
        M((h) => (h.set(m, f), new Map(h)));
      }, []),
      onViewportContentRemove: r.useCallback((m) => {
        M((f) => f.has(m) ? (f.delete(m), new Map(f)) : f);
      }, []),
      children: /* @__PURE__ */ o.jsx(H.Provider, { scope: t, children: /* @__PURE__ */ o.jsx(We, { scope: t, items: b, children: c }) })
    }
  );
}, ue = "NavigationMenuList", le = r.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...a } = e, i = E(ue, n), s = /* @__PURE__ */ o.jsx(T.ul, { "data-orientation": i.orientation, ...a, ref: t });
    return /* @__PURE__ */ o.jsx(T.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ o.jsx(H.Slot, { scope: n, children: i.isRootMenu ? /* @__PURE__ */ o.jsx(Ne, { asChild: !0, children: s }) : s }) });
  }
);
le.displayName = ue;
var de = "NavigationMenuItem", [Ye, we] = Y(de), fe = r.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: a, ...i } = e, s = re(), c = a || s || "LEGACY_REACT_AUTO_VALUE", d = r.useRef(null), u = r.useRef(null), g = r.useRef(null), l = r.useRef(() => {
    }), v = r.useRef(!1), C = r.useCallback((p = "start") => {
      if (d.current) {
        l.current();
        const x = W(d.current);
        x.length && J(p === "start" ? x : x.reverse());
      }
    }, []), R = r.useCallback(() => {
      if (d.current) {
        const p = W(d.current);
        p.length && (l.current = tt(p));
      }
    }, []);
    return /* @__PURE__ */ o.jsx(
      Ye,
      {
        scope: n,
        value: c,
        triggerRef: u,
        contentRef: d,
        focusProxyRef: g,
        wasEscapeCloseRef: v,
        onEntryKeyDown: C,
        onFocusProxyEnter: C,
        onRootContentClose: R,
        onContentFocusOutside: R,
        children: /* @__PURE__ */ o.jsx(T.li, { ...i, ref: t })
      }
    );
  }
);
fe.displayName = de;
var U = "NavigationMenuTrigger", ve = r.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: a, ...i } = e, s = E(U, e.__scopeNavigationMenu), c = we(U, e.__scopeNavigationMenu), d = r.useRef(null), u = F(d, c.triggerRef, t), g = Ce(s.baseId, c.value), l = Re(s.baseId, c.value), v = r.useRef(!1), C = r.useRef(!1), R = c.value === s.value;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(H.ItemSlot, { scope: n, value: c.value, children: /* @__PURE__ */ o.jsx(be, { asChild: !0, children: /* @__PURE__ */ o.jsx(
      T.button,
      {
        id: g,
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-state": Q(R),
        "aria-expanded": R,
        "aria-controls": l,
        ...i,
        ref: u,
        onPointerEnter: y(e.onPointerEnter, () => {
          C.current = !1, c.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: y(
          e.onPointerMove,
          O(() => {
            a || C.current || c.wasEscapeCloseRef.current || v.current || (s.onTriggerEnter(c.value), v.current = !0);
          })
        ),
        onPointerLeave: y(
          e.onPointerLeave,
          O(() => {
            a || (s.onTriggerLeave(), v.current = !1);
          })
        ),
        onClick: y(e.onClick, () => {
          s.onItemSelect(c.value), C.current = R;
        }),
        onKeyDown: y(e.onKeyDown, (p) => {
          const b = { horizontal: "ArrowDown", vertical: s.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[s.orientation];
          R && p.key === b && (c.onEntryKeyDown(), p.preventDefault());
        })
      }
    ) }) }),
    R && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        Oe,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: c.focusProxyRef,
          onFocus: (p) => {
            const x = c.contentRef.current, b = p.relatedTarget, M = b === d.current, P = x?.contains(b);
            (M || !P) && c.onFocusProxyEnter(M ? "start" : "end");
          }
        }
      ),
      s.viewport && /* @__PURE__ */ o.jsx("span", { "aria-owns": l })
    ] })
  ] });
});
ve.displayName = U;
var qe = "NavigationMenuLink", te = "navigationMenu.linkSelect", me = r.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: a, onSelect: i, ...s } = e;
    return /* @__PURE__ */ o.jsx(be, { asChild: !0, children: /* @__PURE__ */ o.jsx(
      T.a,
      {
        "data-active": a ? "" : void 0,
        "aria-current": a ? "page" : void 0,
        ...s,
        ref: t,
        onClick: y(
          e.onClick,
          (c) => {
            const d = c.target, u = new CustomEvent(te, {
              bubbles: !0,
              cancelable: !0
            });
            if (d.addEventListener(te, (g) => i?.(g), { once: !0 }), ee(d, u), !u.defaultPrevented && !c.metaKey) {
              const g = new CustomEvent(L, {
                bubbles: !0,
                cancelable: !0
              });
              ee(d, g);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
me.displayName = qe;
var q = "NavigationMenuIndicator", pe = r.forwardRef((e, t) => {
  const { forceMount: n, ...a } = e, i = E(q, e.__scopeNavigationMenu), s = !!i.value;
  return i.indicatorTrack ? Se.createPortal(
    /* @__PURE__ */ o.jsx(K, { present: n || s, children: /* @__PURE__ */ o.jsx(Xe, { ...a, ref: t }) }),
    i.indicatorTrack
  ) : null;
});
pe.displayName = q;
var Xe = r.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...a } = e, i = E(q, n), s = ie(n), [c, d] = r.useState(
    null
  ), [u, g] = r.useState(null), l = i.orientation === "horizontal", v = !!i.value;
  r.useEffect(() => {
    const p = s().find((x) => x.value === i.value)?.ref.current;
    p && d(p);
  }, [s, i.value]);
  const C = () => {
    c && g({
      size: l ? c.offsetWidth : c.offsetHeight,
      offset: l ? c.offsetLeft : c.offsetTop
    });
  };
  return B(c, C), B(i.indicatorTrack, C), u ? /* @__PURE__ */ o.jsx(
    T.div,
    {
      "aria-hidden": !0,
      "data-state": v ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...a,
      ref: t,
      style: {
        position: "absolute",
        ...l ? {
          left: 0,
          width: u.size + "px",
          transform: `translateX(${u.offset}px)`
        } : {
          top: 0,
          height: u.size + "px",
          transform: `translateY(${u.offset}px)`
        },
        ...a.style
      }
    }
  ) : null;
}), D = "NavigationMenuContent", ge = r.forwardRef((e, t) => {
  const { forceMount: n, ...a } = e, i = E(D, e.__scopeNavigationMenu), s = we(D, e.__scopeNavigationMenu), c = F(s.contentRef, t), d = s.value === i.value, u = {
    value: s.value,
    triggerRef: s.triggerRef,
    focusProxyRef: s.focusProxyRef,
    wasEscapeCloseRef: s.wasEscapeCloseRef,
    onContentFocusOutside: s.onContentFocusOutside,
    onRootContentClose: s.onRootContentClose,
    ...a
  };
  return i.viewport ? /* @__PURE__ */ o.jsx(Je, { forceMount: n, ...u, ref: c }) : /* @__PURE__ */ o.jsx(K, { present: n || d, children: /* @__PURE__ */ o.jsx(
    xe,
    {
      "data-state": Q(d),
      ...u,
      ref: c,
      onPointerEnter: y(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: y(
        e.onPointerLeave,
        O(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !d && i.isRootMenu ? "none" : void 0,
        ...u.style
      }
    }
  ) });
});
ge.displayName = D;
var Je = r.forwardRef((e, t) => {
  const n = E(D, e.__scopeNavigationMenu), { onViewportContentChange: a, onViewportContentRemove: i } = n;
  return z(() => {
    a(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, a]), z(() => () => i(e.value), [e.value, i]), null;
}), L = "navigationMenu.rootContentDismiss", xe = r.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: a,
    triggerRef: i,
    focusProxyRef: s,
    wasEscapeCloseRef: c,
    onRootContentClose: d,
    onContentFocusOutside: u,
    ...g
  } = e, l = E(D, n), v = r.useRef(null), C = F(v, t), R = Ce(l.baseId, a), p = Re(l.baseId, a), x = ie(n), b = r.useRef(null), { onItemDismiss: M } = l;
  r.useEffect(() => {
    const w = v.current;
    if (l.isRootMenu && w) {
      const m = () => {
        M(), d(), w.contains(document.activeElement) && i.current?.focus();
      };
      return w.addEventListener(L, m), () => w.removeEventListener(L, m);
    }
  }, [l.isRootMenu, e.value, i, M, d]);
  const P = r.useMemo(() => {
    const m = x().map((j) => j.value);
    l.dir === "rtl" && m.reverse();
    const f = m.indexOf(l.value), h = m.indexOf(l.previousValue), _ = a === l.value, S = h === m.indexOf(a);
    if (!_ && !S) return b.current;
    const N = (() => {
      if (f !== h) {
        if (_ && h !== -1) return f > h ? "from-end" : "from-start";
        if (S && f !== -1) return f > h ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = N, N;
  }, [l.previousValue, l.value, l.dir, x, a]);
  return /* @__PURE__ */ o.jsx(Ne, { asChild: !0, children: /* @__PURE__ */ o.jsx(
    Fe,
    {
      id: p,
      "aria-labelledby": R,
      "data-motion": P,
      "data-orientation": l.orientation,
      ...g,
      ref: C,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const w = new Event(L, {
          bubbles: !0,
          cancelable: !0
        });
        v.current?.dispatchEvent(w);
      },
      onFocusOutside: y(e.onFocusOutside, (w) => {
        u();
        const m = w.target;
        l.rootNavigationMenu?.contains(m) && w.preventDefault();
      }),
      onPointerDownOutside: y(e.onPointerDownOutside, (w) => {
        const m = w.target, f = x().some((_) => _.ref.current?.contains(m)), h = l.isRootMenu && l.viewport?.contains(m);
        (f || h || !l.isRootMenu) && w.preventDefault();
      }),
      onKeyDown: y(e.onKeyDown, (w) => {
        const m = w.altKey || w.ctrlKey || w.metaKey;
        if (w.key === "Tab" && !m) {
          const h = W(w.currentTarget), _ = document.activeElement, S = h.findIndex((V) => V === _), j = w.shiftKey ? h.slice(0, S).reverse() : h.slice(S + 1, h.length);
          J(j) ? w.preventDefault() : s.current?.focus();
        }
      }),
      onEscapeKeyDown: y(e.onEscapeKeyDown, (w) => {
        c.current = !0;
      })
    }
  ) });
}), X = "NavigationMenuViewport", he = r.forwardRef((e, t) => {
  const { forceMount: n, ...a } = e, s = !!E(X, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ o.jsx(K, { present: n || s, children: /* @__PURE__ */ o.jsx(Qe, { ...a, ref: t }) });
});
he.displayName = X;
var Qe = r.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: a, ...i } = e, s = E(X, n), c = F(t, s.onViewportChange), d = Be(
    D,
    e.__scopeNavigationMenu
  ), [u, g] = r.useState(null), [l, v] = r.useState(null), C = u ? u?.width + "px" : void 0, R = u ? u?.height + "px" : void 0, p = !!s.value, x = p ? s.value : s.previousValue;
  return B(l, () => {
    l && g({ width: l.offsetWidth, height: l.offsetHeight });
  }), /* @__PURE__ */ o.jsx(
    T.div,
    {
      "data-state": Q(p),
      "data-orientation": s.orientation,
      ...i,
      ref: c,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !p && s.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": C,
        "--radix-navigation-menu-viewport-height": R,
        ...i.style
      },
      onPointerEnter: y(e.onPointerEnter, s.onContentEnter),
      onPointerLeave: y(e.onPointerLeave, O(s.onContentLeave)),
      children: Array.from(d.items).map(([M, { ref: P, forceMount: w, ...m }]) => {
        const f = x === M;
        return /* @__PURE__ */ o.jsx(K, { present: w || f, children: /* @__PURE__ */ o.jsx(
          xe,
          {
            ...m,
            ref: Ae(P, (h) => {
              f && h && v(h);
            })
          }
        ) }, M);
      })
    }
  );
}), Ze = "FocusGroup", Ne = r.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...a } = e, i = E(Ze, n);
    return /* @__PURE__ */ o.jsx($.Provider, { scope: n, children: /* @__PURE__ */ o.jsx($.Slot, { scope: n, children: /* @__PURE__ */ o.jsx(T.div, { dir: i.dir, ...a, ref: t }) }) });
  }
), ne = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], et = "FocusGroupItem", be = r.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...a } = e, i = $e(n), s = E(et, n);
    return /* @__PURE__ */ o.jsx($.ItemSlot, { scope: n, children: /* @__PURE__ */ o.jsx(
      T.button,
      {
        ...a,
        ref: t,
        onKeyDown: y(e.onKeyDown, (c) => {
          if (["Home", "End", ...ne].includes(c.key)) {
            let u = i().map((v) => v.ref.current);
            if ([s.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(c.key) && u.reverse(), ne.includes(c.key)) {
              const v = u.indexOf(c.currentTarget);
              u = u.slice(v + 1);
            }
            setTimeout(() => J(u)), c.preventDefault();
          }
        })
      }
    ) });
  }
);
function W(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const i = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || i ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function J(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function tt(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function B(e, t) {
  const n = k(t);
  z(() => {
    let a = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(a), a = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(a), i.unobserve(e);
      };
    }
  }, [e, n]);
}
function Q(e) {
  return e ? "open" : "closed";
}
function Ce(e, t) {
  return `${e}-trigger-${t}`;
}
function Re(e, t) {
  return `${e}-content-${t}`;
}
function O(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Me = se, ye = le, nt = fe, Ee = ve, Te = me, Pe = pe, Ie = ge, _e = he;
const ot = Ve, Z = r.createContext({
  variant: "white",
  layout: "fullWidth"
}), rt = r.forwardRef(({
  className: e,
  children: t,
  variant: n = "white",
  layout: a = "fullWidth",
  ...i
}, s) => /* @__PURE__ */ o.jsx(Z.Provider, { value: {
  variant: n,
  layout: a
}, children: /* @__PURE__ */ o.jsxs(Me, { ref: s, className: I("tw-relative tw-z-[1030] group", a === "tabStrip" ? "tw-box-border tw-flex tw-w-full tw-max-w-[1440px] tw-items-center tw-pt-16 tw-pb-0 tw-pl-24 tw-pr-24" : "tw-flex tw-min-h-[72px] tw-w-full tw-max-w-full tw-items-center tw-px-24", {
  "tw-bg-brand-white tw-text-brand-black [&_a:hover]:tw-text-gray-700": n === "white",
  "tw-bg-brand-black tw-text-brand-white [&_a:hover]:tw-text-gray-500": n === "black"
}, e), ...i, children: [
  /* @__PURE__ */ o.jsxs("span", { itemScope: !0, itemType: "http://schema.org/Organization", className: "tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-h-px tw-w-px tw-overflow-hidden", children: [
    /* @__PURE__ */ o.jsx("link", { itemProp: "url", href: "http://www.peerspace.com/" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "sameAs", content: "http://www.facebook.com/Peerspace" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "sameAs", content: "http://www.x.com/Peerspace" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "sameAs", content: "http://www.pinterest.com/Peerspace" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "sameAs", content: "https://www.youtube.com/user/Peerspace" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "sameAs", content: "https://www.linkedin.com/company/3542206" }),
    /* @__PURE__ */ o.jsx("meta", { itemProp: "logo", content: "https://assets.peerspace.com/ps_logo_dark-v2.svg?v=rb" })
  ] }),
  t,
  /* @__PURE__ */ o.jsx(je, {})
] }) }));
rt.displayName = Me.displayName;
const at = r.forwardRef(({
  className: e,
  ...t
}, n) => {
  const {
    layout: a
  } = r.useContext(Z);
  return /* @__PURE__ */ o.jsx(ye, { ref: n, className: I("tw-group tw-flex tw-list-none tw-gap-24", a === "tabStrip" ? "tw-w-max tw-max-w-none tw-flex-nowrap tw-items-center tw-justify-start" : "tw-min-w-0 tw-w-full tw-flex-1 tw-flex-nowrap tw-items-center tw-justify-center", e), ...t });
});
at.displayName = ye.displayName;
const Tt = nt, it = Ke("tw-group tw-inline-flex tw-h-10 tw-w-max tw-items-center tw-justify-center tw-rounded-md tw-bg-background tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition-colors hover:tw-bg-accent hover:tw-text-accent-foreground focus:tw-bg-accent focus:tw-text-accent-foreground focus:tw-outline-none disabled:tw-pointer-events-none disabled:tw-opacity-50 data-[active]:tw-bg-accent/50 data-[state=open]:tw-bg-accent/50"), st = r.forwardRef(({
  className: e,
  children: t,
  ...n
}, a) => /* @__PURE__ */ o.jsxs(Ee, { ref: a, className: I(it(), "tw-group", e), ...n, children: [
  t,
  " ",
  /* @__PURE__ */ o.jsx(ot, { className: "tw-relative tw-top-[1px] tw-ml-1 tw-h-3 tw-w-3 tw-transition tw-duration-200 group-data-[state=open]:tw-rotate-180", "aria-hidden": "true" })
] }));
st.displayName = Ee.displayName;
const ct = r.forwardRef(({
  className: e,
  ...t
}, n) => /* @__PURE__ */ o.jsx(Ie, { ref: n, className: I("tw-left-0 tw-top-0 tw-w-full data-[motion^=from-]:tw-animate-in data-[motion^=to-]:tw-animate-out data-[motion^=from-]:tw-fade-in data-[motion^=to-]:tw-fade-out data-[motion=from-end]:tw-slide-in-from-right-52 data-[motion=from-start]:tw-slide-in-from-left-52 data-[motion=to-end]:tw-slide-out-to-right-52 data-[motion=to-start]:tw-slide-out-to-left-52 md:tw-absolute md:tw-w-auto", e), ...t }));
ct.displayName = Ie.displayName;
const ut = r.forwardRef(({
  className: e,
  selected: t,
  ...n
}, a) => {
  const {
    variant: i,
    layout: s
  } = r.useContext(Z), c = s === "tabStrip", d = "tw-inline-flex tw-shrink-0 tw-items-start tw-gap-8 tw-whitespace-nowrap tw-pb-16 tw-border-b-2 tw-body-1-m tw-transition-colors";
  let u;
  !c || t === void 0 ? u = void 0 : t ? u = i === "white" ? "tw-border-black tw-text-gray-900" : "tw-border-white tw-text-white" : u = "tw-border-transparent tw-text-gray-500";
  const g = c && t !== void 0;
  return /* @__PURE__ */ o.jsx(Te, { ref: a, className: I("tw-outline-none focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-gray-400 focus-visible:tw-ring-offset-2", g ? d : I("tw-body-1-m", !c && "tw-font-bold"), u, e), "aria-current": c && t ? "page" : void 0, ...n });
});
ut.displayName = Te.displayName;
const je = r.forwardRef(({
  className: e,
  ...t
}, n) => /* @__PURE__ */ o.jsx("div", { className: I("tw-absolute tw-left-0 tw-top-full tw-flex tw-justify-center"), children: /* @__PURE__ */ o.jsx(_e, { className: I("tw-origin-top-center tw-relative tw-mt-1.5 tw-h-[var(--radix-navigation-menu-viewport-height)] tw-w-full tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-text-popover-foreground tw-shadow-lg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-90 md:tw-w-[var(--radix-navigation-menu-viewport-width)]", e), ref: n, ...t }) }));
je.displayName = _e.displayName;
const lt = r.forwardRef(({
  className: e,
  ...t
}, n) => /* @__PURE__ */ o.jsx(Pe, { ref: n, className: I("tw-top-full tw-z-[1] tw-flex tw-h-1.5 tw-items-end tw-justify-center tw-overflow-hidden data-[state=visible]:tw-animate-in data-[state=hidden]:tw-animate-out data-[state=hidden]:tw-fade-out data-[state=visible]:tw-fade-in", e), ...t, children: /* @__PURE__ */ o.jsx("div", { className: "tw-relative tw-top-[60%] tw-h-2 tw-w-2 tw-rotate-45 tw-rounded-tl-sm tw-bg-border tw-shadow-md" }) }));
lt.displayName = Pe.displayName;
export {
  rt as N,
  at as a,
  Tt as b,
  ct as c,
  st as d,
  ut as e,
  lt as f,
  je as g,
  it as n
};
//# sourceMappingURL=Nav.D7EuGsBi.js.map
